import script from "./Cursor.vue?vue&type=script&lang=ts&setup=true"
export * from "./Cursor.vue?vue&type=script&lang=ts&setup=true"

import "./Cursor.vue?vue&type=style&index=0&id=01e1d906&lang=postcss&scoped=true"

import exportComponent from "/Users/benedge/Projects/KPMG-30-Voices-FS-2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01e1d906"]])

export default __exports__